import ActivationSiteSynchroController from './activation.site.synchro.controller';

export default {
    template: require('./activation.site.synchro.html'),
    controller: ActivationSiteSynchroController
};
